import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PetitionAbsencePage } from './petition-absence';

@NgModule({
  declarations: [
    PetitionAbsencePage,
  ],
  imports: [
    IonicPageModule.forChild(PetitionAbsencePage),
  ],
})
export class PetitionAbsencePageModule {}



// WEBPACK FOOTER //
// ./src/pages/petition-absence/petition-absence.module.ts